//#region Icons
import BooksIcon from './adminIcons/book-stack.png';
import Logs from './adminIcons/bug.png';
import Corporate from './adminIcons/business.png';
import Cache from './adminIcons/data.png';
import ContentManagment from './adminIcons/digital-asset.png';
import ProductAssignment from './adminIcons/direct-marketing.png';
import Feedback from './adminIcons/feedback.png';
import CMS from './adminIcons/folder.png';
import Members from './adminIcons/group.png';
import Coaching from './adminIcons/leadership.png';
import WorkList from './adminIcons/list.png';
import OnlineLecture from './adminIcons/online-content.png';
import VideoSolution from './adminIcons/podcast.png';
import Credit from './adminIcons/salary.png';
import TopicSelection from './adminIcons/task-list.png';
import AchievementSelection from './adminIcons/task-list.png';
import KPSSComp from './adminIcons/task.png';
import CMSApprove from './adminIcons/validation.png';
import Analytics from './adminIcons/analytics.png';
//#endregion

import { Text } from './Strings';

/**
 * Role identifiers, exactly matching the values stored on `user.Role`.
 */
export const Roles = {
    Administrators: 'Administrators',
    OnlineLectureContentCreator: 'OnlineLectureContentCreator',
    TeacherEditors: 'TeacherEditors',
    ContentApprovers: 'ContentApprovers',
    DataAnalysts: 'DataAnalysts',
    Developers: 'Developers',
    CoachAdmins: 'CoachAdmins',
    ContentManagers: 'ContentManagers'
};

/**
 * Section names, in the order they should appear on the dashboard and in the
 * Administrator sidebar.
 */
export const MenuGroups = [
    'Users & Sales',
    'Content & Books',
    'CMS / Questions',
    'Live & Interactive Video',
    'Coaching',
    'Analytics',
    'System & Logs'
];

/**
 * Single source of truth for every navigable admin/role page.
 *
 * Each item is listed exactly once (deduplicated by `path`), which is what
 * removes the duplicate entries the Administrator sidebar used to show.
 *
 * Visibility rules:
 *  - `roles`        : the page is shown to any user whose role is in this list.
 *  - `rolesExclude` : the page is shown to every role EXCEPT those listed
 *                     (used by Work List, which targets "everyone but these").
 *
 * `title` doubles as the sidebar highlight key, so the four pages that dispatch
 * a selected value (Members, Books, Work List, FeedBacks) keep the same strings.
 */
export const MenuItems = [
    // Users & Sales
    {
        title: Text.Members,
        path: '/members',
        icon: Members,
        group: 'Users & Sales',
        roles: [Roles.Administrators]
    },
    {
        title: 'Credits',
        path: '/usercredits',
        icon: Credit,
        group: 'Users & Sales',
        roles: [Roles.Administrators]
    },
    {
        title: 'Ürün Atama',
        path: '/ProductAssignment',
        icon: ProductAssignment,
        group: 'Users & Sales',
        roles: [Roles.Administrators]
    },
    {
        title: 'Corporate',
        path: '/Corporate',
        icon: Corporate,
        group: 'Users & Sales',
        roles: [Roles.Administrators]
    },

    // Content & Books
    {
        title: Text.Books,
        path: '/books',
        icon: BooksIcon,
        group: 'Content & Books',
        roles: [Roles.Administrators]
    },
    {
        title: Text.WorkList,
        path: '/worklist',
        icon: WorkList,
        group: 'Content & Books',
        rolesExclude: [
            Roles.OnlineLectureContentCreator,
            Roles.TeacherEditors,
            Roles.ContentApprovers,
            Roles.CoachAdmins,
            Roles.Developers,
            Roles.ContentManagers,
            Roles.DataAnalysts
        ]
    },
    {
        title: 'Content Management',
        path: '/contentManagment',
        icon: ContentManagment,
        group: 'Content & Books',
        roles: [Roles.OnlineLectureContentCreator, Roles.ContentManagers, Roles.Administrators]
    },
    {
        title: 'FeedBacks',
        path: '/feedbacks',
        icon: Feedback,
        group: 'Content & Books',
        roles: [Roles.ContentManagers, Roles.Administrators]
    },

    // CMS / Questions
    {
        title: 'CMS',
        path: '/NewTopicAndAchSelectionCoursePage',
        icon: CMS,
        group: 'CMS / Questions',
        roles: [Roles.TeacherEditors, Roles.Administrators]
    },
    {
        title: 'CMS Onaylama',
        path: '/NewQuestionApproveCoursePage',
        icon: CMSApprove,
        group: 'CMS / Questions',
        roles: [Roles.ContentApprovers, Roles.Administrators]
    },
    // {
    //     title: 'KPSS Soru Eşleştirme',
    //     path: '/KpssCompatibilityCourses',
    //     icon: KPSSComp,
    //     group: 'CMS / Questions',
    //     roles: [Roles.TeacherEditors, Roles.Administrators]
    // },
    // {
    //     title: 'Sorulara Kazanım Ekleme',
    //     path: '/AchievementCourses',
    //     icon: AchievementSelection,
    //     group: 'CMS / Questions',
    //     roles: [Roles.TeacherEditors, Roles.Administrators]
    // },
    // {
    //     title: 'Sorulara Konu Ekleme',
    //     path: '/questionSubTopicSelectionCoursePage',
    //     icon: TopicSelection,
    //     group: 'CMS / Questions',
    //     roles: [Roles.TeacherEditors, Roles.Administrators]
    // },
    {
        title: 'Soru Video Çözüm Paneli',
        path: '/questionVideoSolution',
        icon: VideoSolution,
        group: 'CMS / Questions',
        roles: [Roles.TeacherEditors, Roles.Administrators]
    },
    {
        title: 'CMS Analiz',
        path: '/CMSAnalysis',
        icon: Analytics,
        group: 'Analytics',
        roles: [Roles.Administrators]
    },
    {
        title: 'CMS Reports',
        path: '/CMSReports',
        icon: Feedback,
        group: 'CMS / Questions',
        roles: [Roles.Administrators]
    },
    // Live & Interactive Video
    {
        title: 'Canlı Ders Paneli',
        path: '/onlineLecturePanel',
        icon: OnlineLecture,
        group: 'Live & Interactive Video',
        roles: [Roles.OnlineLectureContentCreator, Roles.ContentManagers, Roles.Administrators]
    },
    {
        title: 'İnteraktif Video',
        path: '/VideoInteractionDashboard',
        icon: OnlineLecture,
        group: 'Live & Interactive Video',
        roles: [Roles.TeacherEditors, Roles.ContentManagers, Roles.Administrators]
    },

    // Coaching
    {
        title: 'Coaches',
        path: '/CoachesAdminPanel',
        icon: Coaching,
        group: 'Coaching',
        roles: [Roles.CoachAdmins, Roles.Administrators]
    },

    // Analytics
    {
        title: 'Analytics Page',
        path: '/AnalyticsPage',
        icon: Analytics,
        group: 'Analytics',
        roles: [Roles.DataAnalysts, Roles.Administrators]
    },

    // System & Logs
    {
        title: 'Cache',
        path: '/caches',
        icon: Cache,
        group: 'System & Logs',
        roles: [Roles.Administrators]
    },
    {
        title: 'Application Logs',
        path: '/AppLogs',
        icon: Logs,
        group: 'System & Logs',
        roles: [Roles.Developers, Roles.Administrators]
    }
];

/**
 * True when `item` should be visible to the given role.
 */
export const isVisibleForRole = (item, role) => {
    if (item.rolesExclude) {
        return !item.rolesExclude.includes(role);
    }
    return Array.isArray(item.roles) && item.roles.includes(role);
};

/**
 * Flat, deduplicated list of menu items for a role (used by the sidebar).
 */
export const getMenuItemsForRole = (role) => {
    if (!role) {
        return [];
    }
    return MenuItems.filter((item) => isVisibleForRole(item, role));
};

/**
 * Menu items for a role, grouped by section and preserving `MenuGroups` order.
 * Empty groups are omitted. Used by the dashboard.
 */
export const getGroupedMenuItemsForRole = (role) => {
    const items = getMenuItemsForRole(role);
    return MenuGroups
        .map((group) => ({
            group,
            items: items.filter((item) => item.group === group)
        }))
        .filter((section) => section.items.length > 0);
};
